import { Alert, Typography } from '@mui/material'
import { pagesPath } from '~/lib/$path'
import { LinkToInfo } from './LinkToInfo'

export const CreditCardRegistrationAlert = () => {
  return (
    <Alert severity="warning">
      <Typography variant="body2">立替型キャンペーンの作成には、クレジットカードのご登録が必要です。</Typography>
      <LinkToInfo
        href={pagesPath.adv_account.credit_registration.$url().pathname}
        textBefore="クレジットカードのご登録は"
        textAfter="からお願いいたします。"
      />
    </Alert>
  )
}
